import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import type { Variant } from '../../types'
import ActionTypes from './actionTypes'

type FetchVariantRequest = {
    type: typeof ActionTypes.VARIANT_ID_FETCH_REQUEST;
    payload: never;
}

type FetchVariantFailure = {
    type: typeof ActionTypes.VARIANT_ID_FETCH_FAILURE;
    payload: Error;
}

type FetchVariantSuccess = {
    type: typeof ActionTypes.VARIANT_ID_FETCH_SUCCESS;
    payload: Variant;
}

function fetchVariant(id: number) {
    return createAction<RootState, Variant, never>({
        endpoint: `${HUBBLE_API_TOKEN}/ticket-variants/${id}`,
        method: 'GET',
        types: [
            ActionTypes.VARIANT_ID_FETCH_REQUEST,
            ActionTypes.VARIANT_ID_FETCH_SUCCESS,
            ActionTypes.VARIANT_ID_FETCH_FAILURE,
        ],
    })
}

export type FetchVariantIDAction = FetchVariantRequest
    | FetchVariantFailure
    | FetchVariantSuccess

export default fetchVariant
